/**
 * 邮箱
 * @param {*} s
 */
 export function isEmail(s) {
    return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
    return /^[1][3-9][0-9]{9}$/.test(s)
}
//手机虚拟号屏蔽验证
export function  isBlockedPhoneNumber(phoneNumber){
    // 正则表达式，匹配以1704或1707开头的手机号  
    const blockedPatterns = [/^1704/, /^1707/,/^1708/,/^1709/,/^171/,/^146/,/^167/,/^141/,
        /^149/,/^1700/,/^1701/,/^1702/,/^162/,/^174/,/^165/,/^1703/,/^1706/,/^1705/];  
  
    // 检查手机号是否匹配任意一个屏蔽模式  
    for (const pattern of blockedPatterns) {  
        if (pattern.test(phoneNumber)) {  
            return true; // 匹配到了屏蔽模式，返回true  
        }  
    }  
  
    return false; // 没有匹配到屏蔽模式，返回false  
}



/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
    return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
    return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 姓名
 * @param {*} str
 */
export function valName(str) {
    return /^[\u4e00-\u9fa5]{2,10}$/.test(str)
}

/**
 * 非空
 * @param {*} s
 */

export function isEmpty(s) {
    return s.trim().length > 0
}
/**
 * 身份证号
 * @param {*} s
 */
export function isIdNo(s) {
    return /^[0-9A-Za-z]{18}$/.test(s)
}

/**
 * 是否为安卓环境
 * @param {*}
 */
export function isAndroid() {
    // 获取UserAgent
    const u = navigator.userAgent
    if (/(iPhone|iPad|iPod|iOS|Macintosh|Mac OS X)/i.test(u)) {
        // ios终端
       return false
    }else {
       return true
    }
}

/**
 * 是安卓还是ios
 */
export function isAndroidIos() {
    const u = navigator.userAgent
    let result = 'unknown'
    if (u.indexOf('Linux') > -1||u.indexOf('Android') > -1 || u.indexOf('Adr') > -1|| u.indexOf('VivoBrowser') > -1|| u.indexOf('HuaweiBrowser') > -1|| u.indexOf('HeyTapBrowser') > -1|| u.indexOf('MiuiBrowser') > -1) {
        // android终端
        result = 'Android'
    }
    if (/(iPhone|iPad|iPod|iOS)/i.test(u)) {
        // ios终端
        result = 'iOS'
    }
    return result
}
// 键盘弹起，输入框被遮挡
export function judgeInput() {
    if (!isAndroid()) {
      window.addEventListener('focusin', function () {

        if (
          document.activeElement.tagName === 'INPUT' ||
          document.activeElement.tagName === 'TEXTAREA'
        ) {
          setTimeout(function () {
            document.documentElement.scrollTop = document.body.scrollHeight;
          }, 0);
        }
      });
    } else {
      window.addEventListener('resize', function () {
        
        if (
          document.activeElement.tagName === 'INPUT' ||
          document.activeElement.tagName === 'TEXTAREA'
        ) {
          setTimeout(function () {
            document.activeElement.scrollIntoView();
          }, 0);
        }
      });
    }

}


// 键盘弹起，输入框被遮挡 2.0版本
export function judgeInput2(className) {

    const keyboardList = document.querySelector(`.${className}`)
    keyboardList.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'  // 确保元素位于视口中央
    })
}


export function translateTime(o) {
    const date = new Date(o)
    const Y = date.getFullYear() + '-'
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    const D = date.getDate() + ' '
    return Y + M + D
}

// 截取银行卡号后四位
export function binkTail(n) {
    return n.substring(n.length - 4)
}

// 分割千分符
export function splitQ(num) {

    const reg = /\d{1,3}(?=(\d{3})+$)/g
    return (num + '').replace(reg, '$&,')
}

// 是否是微信内打开
export function isWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase()
    const match = ua.match(/MicroMessenger/i)
    if (match === null) {
        return false
    }
    if (match.includes('micromessenger')) {
        return true
    }
    return false
}


//手机号脱敏
export function phoneHide(phone='') {
    return phone? phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'):""
}

//姓名脱敏
export function nameHide(name='') {
    return name ? name.replace(/^([\u4e00-\u9fa5])([\u4e00-\u9fa5]*)([\u4e00-\u9fa5])$/, (_, g1, g2, g3) => 
        `${g1}${'*'.repeat(g2.length)}${g3}`
    ).replace(/^([\u4e00-\u9fa5])([\u4e00-\u9fa5])$/, '$1*') : ""
}

export function formatDate() {
    const date = new Date();
    const year = date.getFullYear();
    // 月份补零
    const month = String(date.getMonth() + 1).padStart(2, '0');
    // 日期补零
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const APP_AVATAR  = 'https://img.gengguangcj.cn/'


// WEBPACK FOOTER //
// ./src/utils/validate.js